import styled from 'styled-components';
import Theme from '@carrot-deprecated/theme';

const Separator = styled.div`
  border-bottom: 1px solid ${Theme.Colours.lightGrey};
`;

export default Separator;
